<template>
  <div class="ag-label">
    <div class="d-flex flex-column">
      <span class="ag-label__label" :class="[fontWeightClass, fontSizeClass]" :data-qa="normalizeQa(labelDataQa)">
        <slot name="label">
          {{ label }}
        </slot>
      </span>
      <v-progress-linear v-if="loading" color="#ECE7F5" height="38px" class="mb-2 rounded" indeterminate />
      <span v-else class="ag-label__value"><slot /></span>
    </div>
    <div><slot name="append" /></div>
  </div>
</template>

<script>
import UtilsString from '@/utils/UtilsString';

export default {
  name: 'AGLabel',
  props: {
    label: {
      type: String,
      required: true,
    },
    labelDataQa: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fontWeight: {
      type: String,
      default: 'regular',
      validator: (value) => ['regular', 'bold'].includes(value),
    },
    fontSize: {
      type: String,
      default: 'xxxs',
      validator: (value) => ['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl'].includes(value),
    },
  },

  computed: {
    fontWeightClass() {
      return `ag-label__label--${this.fontWeight}`;
    },
    fontSizeClass() {
      return `ag-label__label--${this.fontSize}`;
    },
  },
  methods: {
    normalizeQa: UtilsString.normalizeQa,
  },
};
</script>

<style scoped lang="scss">
.ag-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.ag-label__label {
  line-height: $line-height-md;
  color: $neutral-color-high-medium;
  &--regular {
    font-weight: $font-weight-regular;
  }
  &--bold {
    font-weight: $font-weight-bold;
  }
  &--xxxs {
    font-size: $font-size-xxxs;
  }
  &--xxs {
    font-size: $font-size-xxs;
  }
  &--xs {
    font-size: $font-size-xs;
  }
  &--sm {
    font-size: $font-size-sm;
  }
  &--md {
    font-size: $font-size-md;
  }
  &--lg {
    font-size: $font-size-lg;
  }
  &--xl {
    font-size: $font-size-xl;
  }
}
</style>
